<template>
  <div v-if="this.custom" ref='btntooltip' class="mw34" :data-bs-placement="this.placement" data-bs-toggle="tooltip" :title="this.content">
    <i :class="this.custom"></i>
  </div>
  <div v-else ref='btntooltip'  class='bs-tooltip mw34' :data-bs-placement="this.placement" data-bs-toggle="tooltip" :title="this.content">
  
  </div>
</template>

<script>
  import { Tooltip } from 'bootstrap';
  export default {
    components: {
    },
    props: {
        content: {
            type: [String, Boolean],
            default: 'Some hint',
        },
        hover: {
            type: Boolean,
            default: true,
        },
        placement: {
            type: String,
            default: 'top',
        },
        custom: [String, Boolean]
    },
    data() {
      return {
        tool: false,
      }
    },
    mounted() {
      this.bp();
    },
    updated() {
      this.tool.dispose();
      this.bp();
    },
  
    beforeUnmount() {
      this.tool.dispose();
    },
    methods: {
      bp() {
        this.tool = new Tooltip(this.$refs.btntooltip);
      }
    },
  };
</script>

<style lang="scss">
.bs-tooltip {
  width: 26px;
  height: 26px;
  background-image: url('~@/assets/bi_question-circle.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 23px;
  cursor: pointer;
  margin: 0 5px;
}
</style>